import React from 'react';
import { shape, string, number, bool } from 'prop-types';

import styles from '../../styles.module.scss';
import PriceRow from '../PriceRow';

function Summary({ prices }) {
  return (
    <div className={`m-top-1 m-left-2 m-right-2 ${styles.border}`}>
      <div className="column space-around">
        {Object.values(prices).map(({ text, value, bold, discount, hasDivider, noMoneySymbol, metadata }) => (
          <PriceRow
            key={text}
            text={text}
            value={value}
            bold={bold}
            discount={discount}
            hasDivider={hasDivider}
            noMoneySymbol={noMoneySymbol}
            metadata={metadata}
          />
        ))}
      </div>
    </div>
  );
}

Summary.propTypes = {
  prices: shape({
    text: string,
    value: number,
    bold: bool,
    discount: bool,
    noMoneySymbol: bool
  })
};

Summary.defaultProps = {
  prices: {
    noMoneySymbol: false
  }
};
export default Summary;
